(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[22,2576,5124,949],{

/***/ 1421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ customer_data_maturity_resources; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/FooterCompact/index.ts + 2 modules
var FooterCompact = __webpack_require__(69524);
// EXTERNAL MODULE: ../../libs/templates/NavigationBrand/index.ts + 3 modules
var NavigationBrand = __webpack_require__(22761);
// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../libs/templates/DividerSection/index.ts
var DividerSection = __webpack_require__(85507);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityResources/components/Hero/Hero.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var copy = {
  heading: "Customer Data Maturity: How&nbsp;the World\u2019s Biggest Companies Win by Unlocking Customer Potential",
  subheading: "by Twilio Segment",
  description: "Welcome to the resources hub for our comprehensive guide to Customer Data Maturity. If you made it to this page, presumably your goal is to develop data strategies that actively unlock business opportunities. The path to data maturity first and foremost requires adopting a customer data platform (CDP) such as Twilio Segment to gain a complete understanding of your customer. Your CDP serves as the essential foundation of the modern data stack by integrating and organizing data from every data source, platform, and channel to create a unified customer file.",
  caption: "To help guide you through your book, we\u2019ve collected a series of resources to aid you on your customer data journey:"
};

var Hero = function Hero() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroComponent, {
      variant: "article",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Contents */.AU, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
          variant: "h1",
          tag: "h1",
          dangerouslySetInnerHTML: {
            __html: copy.heading
          }
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subheading, {
          variant: "pLarge",
          tokens: {
            color: theme.palette.twilio.gray[80]
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("em", {
            children: copy.subheading
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
          variant: "pLarge",
          tokens: {
            color: theme.palette.twilio.gray[80]
          },
          children: copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
          variant: "pLarge",
          tokens: {
            color: theme.palette.twilio.gray[80]
          },
          children: copy.caption
        })]
      })
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "ev8bwdx2"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var HeroComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "ev8bwdx1"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("xl");
}, "{padding-left:218px;}", recipes_Hero/* Wrapper */.im, "{gap:0;", recipes_Hero/* Contents */.AU, "{justify-items:start;}}" + ( true ? "" : 0));

var Subheading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ev8bwdx0"
} : 0)( true ? {
  name: "1i9vogi",
  styles: "margin-top:0"
} : 0);

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityResources/components/ResourcesSection/ResourcesSection.tsx


function ResourcesSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var ResourcesSection = function ResourcesSection(_ref) {
  var title = _ref.title,
      resources = _ref.resources;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Contents */.AU, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
        variant: "h2",
        tag: "h2",
        children: title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
        columns: 1,
        overrides: {
          md: 2,
          lg: 3
        },
        children: resources.map(function (_ref2) {
          var title = _ref2.title,
              asset = _ref2.asset,
              type = _ref2.type,
              categories = _ref2.categories,
              excerpt = _ref2.excerpt,
              authorLogo = _ref2.authorLogo,
              authorName = _ref2.authorName,
              button = _ref2.button,
              href = _ref2.href;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* default */.ZP, {
            href: href,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardImage, {
              variant: "fill",
              src: asset,
              alt: ""
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Accessories */.v8, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* AccessoriesRow */.OW, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Label */.__, {
                    children: type
                  })
                }), categories && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* AccessoriesRow */.OW, {
                  children: categories.map(function (category) {
                    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
                      variant: "outlined",
                      children: category
                    }, category);
                  })
                })]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                  tag: "h3",
                  children: title
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                  children: excerpt
                }), authorLogo && authorName && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* AccessoriesRow */.OW, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Author */.S3, {
                    src: authorLogo,
                    alt: "",
                    size: "small"
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Label */.__, {
                    variant: "textTiny",
                    children: authorName
                  })]
                })]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
                  size: "medium",
                  iconEnd: Common/* ChevronRightIcon */.XC,
                  children: button
                })
              })]
            })]
          }, title);
        })
      })]
    })
  });
};

var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e16v4p1g1"
} : 0)( true ? {
  name: "1o1e2ls",
  styles: "margin-top:0;margin-bottom:40px"
} : 0);

var CardImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* Image */.Ee,  true ? {
  target: "e16v4p1g0"
} : 0)(function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{height:209px;}" + ( true ? "" : 0));

/* harmony default export */ var ResourcesSection_ResourcesSection = (ResourcesSection);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturityResources/assets/The4StepGuide.png
var The4StepGuide = __webpack_require__(89796);
var The4StepGuide_default = /*#__PURE__*/__webpack_require__.n(The4StepGuide);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturityResources/assets/WhatDoesItTake.png
var WhatDoesItTake = __webpack_require__(48319);
var WhatDoesItTake_default = /*#__PURE__*/__webpack_require__.n(WhatDoesItTake);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturityResources/assets/JumpstartLite.png
var JumpstartLite = __webpack_require__(74253);
var JumpstartLite_default = /*#__PURE__*/__webpack_require__.n(JumpstartLite);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturityResources/assets/AnalyticsAcademy.png
var AnalyticsAcademy = __webpack_require__(61368);
var AnalyticsAcademy_default = /*#__PURE__*/__webpack_require__.n(AnalyticsAcademy);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturityResources/assets/CustomerStoryIbm.png
var CustomerStoryIbm = __webpack_require__(84985);
var CustomerStoryIbm_default = /*#__PURE__*/__webpack_require__.n(CustomerStoryIbm);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturityResources/assets/DefaultThumbnail2.png
var DefaultThumbnail2 = __webpack_require__(58951);
var DefaultThumbnail2_default = /*#__PURE__*/__webpack_require__.n(DefaultThumbnail2);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturityResources/assets/StreamlineCompliance.png
var StreamlineCompliance = __webpack_require__(90032);
var StreamlineCompliance_default = /*#__PURE__*/__webpack_require__.n(StreamlineCompliance);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturityResources/assets/DefaultThumbnail.png
var DefaultThumbnail = __webpack_require__(84257);
var DefaultThumbnail_default = /*#__PURE__*/__webpack_require__.n(DefaultThumbnail);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturityResources/assets/CustomerStoryFender.png
var CustomerStoryFender = __webpack_require__(1866);
var CustomerStoryFender_default = /*#__PURE__*/__webpack_require__.n(CustomerStoryFender);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturityResources/assets/IdentityResolutionGuide.png
var IdentityResolutionGuide = __webpack_require__(141);
var IdentityResolutionGuide_default = /*#__PURE__*/__webpack_require__.n(IdentityResolutionGuide);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturityResources/assets/CustomerStoryToggle.png
var CustomerStoryToggle = __webpack_require__(45389);
var CustomerStoryToggle_default = /*#__PURE__*/__webpack_require__.n(CustomerStoryToggle);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturityResources/assets/CustomerStoryEndeavor.png
var CustomerStoryEndeavor = __webpack_require__(83063);
var CustomerStoryEndeavor_default = /*#__PURE__*/__webpack_require__.n(CustomerStoryEndeavor);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturityResources/assets/CustomerStoryDominos.png
var CustomerStoryDominos = __webpack_require__(14946);
var CustomerStoryDominos_default = /*#__PURE__*/__webpack_require__.n(CustomerStoryDominos);
// EXTERNAL MODULE: ./src/views/CustomerDataMaturityResources/assets/CustomerStoryAllergan.png
var CustomerStoryAllergan = __webpack_require__(80408);
var CustomerStoryAllergan_default = /*#__PURE__*/__webpack_require__.n(CustomerStoryAllergan);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityResources/assets/AuthorLogo.png
/* harmony default export */ var AuthorLogo = ("data:image/png;base64,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");
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityResources/data.tsx
















var LEARN_URL = "https://learn.segment.com";
var UNIVERSITY_URL = "https://university.segment.com";
var TWILIO_URL = "https://www.twilio.com";

var data = function data(pageConfig) {
  return [{
    title: "Introduction",
    resources: [{
      asset: (The4StepGuide_default()),
      type: "Guide",
      categories: ["Customer Data Platform (CDP)", "Marketing", "Growth", "Analytics"],
      title: "The 4-Step Guide to CDP Success",
      excerpt: "Managing a customer data platform project can feel like a treacherous mountain expedition. To meet the business and technical requirements involved with your CDP project you need a comprehensive plan for implementation to ensure success. Our new guide makes the journey easier by con...",
      button: "Read it here",
      href: (0,getAbsoluteUrl/* default */.Z)("/guide-to-cdp-success/", {
        baseUrl: LEARN_URL,
        basePath: pageConfig.basePath
      })
    }, {
      asset: (WhatDoesItTake_default()),
      type: "Blog",
      categories: ["Growth & Marketing"],
      title: "What Does it Take to Achieve Good Data at Enterprise Scale?",
      excerpt: "In this post, you\u2019ll learn why data is worth standardizing, two models of ownership for driving data standards at your company, and how to stay agile in the process.",
      button: "Read it here",
      href: (0,getAbsoluteUrl/* default */.Z)("https://segment.com/blog/what-does-it-take-to-achieve-good-data-at-enterprise-scale/", pageConfig)
    }]
  }, {
    title: "Foundational Maturity",
    resources: [{
      asset: (JumpstartLite_default()),
      type: "Segment University",
      title: "Jumpstart Lite for Existing Segment Customers",
      excerpt: "For hands-on practice, we recommend trying the \u201CGoals & Use-Cases\u201D activity in our Jumpstart Lite program (for existing Segment Customers on Segment University).",
      button: "Find it here",
      href: (0,getAbsoluteUrl/* default */.Z)("/jumpstart-lite-for-existing-segment-customers/", {
        baseUrl: UNIVERSITY_URL,
        basePath: pageConfig.basePath
      })
    }, {
      asset: (AnalyticsAcademy_default()),
      type: "Analytics Academy",
      title: "Choosing Metrics that Matter",
      excerpt: "Everyone loves their wall-mounted dashboards, but we rarely pick the right metrics to track. And tracking the wrong metrics is almost as bad as tracking nothing at all. Here's what you need to know about selecting actionable metrics.",
      button: "Read it here",
      href: (0,getAbsoluteUrl/* default */.Z)("/academy/intro/choosing-metrics-that-matter/", pageConfig)
    }, {
      asset: (CustomerStoryIbm_default()),
      type: "Customer Story",
      title: "How IBM Scaled its Customer Data Foundation Across 150 Products",
      excerpt: "This case study highlights how IBM partnered with Twilio Segment to scale its customer data infrastructure and drive increased customer adoption, engagement and expansion.",
      button: "Read their story",
      href: (0,getAbsoluteUrl/* default */.Z)("/customers/ibm/", pageConfig)
    }, {
      asset: (DefaultThumbnail2_default()),
      type: "Blog",
      title: "First Party Data: How to Activate & Leverage Your Data",
      excerpt: "We outline a path to building trust in data across your organization, and explain why it's critical to lay the right infrastructure and process for how data is collected, cleaned, governed, and acted on.",
      button: "Read it here",
      href: (0,getAbsoluteUrl/* default */.Z)("https://segment.com/blog/first-party-data-guide/", pageConfig)
    }, {
      asset: (StreamlineCompliance_default()),
      type: "Recipe",
      categories: ["Startup", "Mobile", "Marketplace", "Media", "B2B"],
      title: "Streamline Compliance with End-User Privacy Tools",
      excerpt: "In this recipe, you\u2019ll learn how to save time complying with user deletion and suppression requests by using Segment\u2019s deletion features.",
      authorLogo: AuthorLogo,
      authorName: "Made by Segment",
      button: "Use this recipe",
      href: (0,getAbsoluteUrl/* default */.Z)("/recipes/streamline-GDPR-compliance-with-Segment-end-user-privacy-tools/", pageConfig)
    }, {
      asset: (DefaultThumbnail_default()),
      type: "Blog",
      categories: ["Identity Management"],
      title: "Identity Resolution: The Definitive Guide",
      excerpt: "At Segment, our customer data platform has helped thousands of businesses merge the complete history of each customer into a single profile. That\u2019s why we\u2019ve put together this short guide, to help you understand the nuts and bolts of identity resolution, and how you can bring it into your organization.",
      button: "Read it here",
      href: (0,getAbsoluteUrl/* default */.Z)("https://segment.com/blog/identity-resolution/", pageConfig)
    }, {
      asset: (CustomerStoryFender_default()),
      type: "Customer Story",
      title: "How Fender Improves Customer Engagement with Quality Data",
      excerpt: "Fender turned to Twilio Segment to create a single source of truth by unifying customer data. Now Fender's marketing and product teams can query events and traits with Segment\u2019s self-service audience builder and create cohorts of users for more target messaging. And API access to user profiles...",
      button: "Read their story",
      href: (0,getAbsoluteUrl/* default */.Z)("/customers/fender/", pageConfig)
    }, {
      asset: (IdentityResolutionGuide_default()),
      type: "Guide",
      categories: ["Analytics", "Customer Data Platform (CDP)", "Marketing", "Growth"],
      title: "Identity Resolution: A Guide to the Post-Cookie World",
      excerpt: "Due to growing consumer expectations for personalization and privacy, companies need to take a hard look at identity resolution. This guide walks you through the common challenges and required capabilities of a successful first-party identity resolution strategy.",
      button: "Read it here",
      href: (0,getAbsoluteUrl/* default */.Z)("/identity-resolution/", {
        baseUrl: LEARN_URL,
        basePath: pageConfig.basePath
      })
    }, {
      asset: (CustomerStoryToggle_default()),
      type: "Customer Story",
      title: "How Toggle Speeds into New Markets with Connected Data",
      excerpt: "With the launch of Toggle (a Farmers Insurance company) the technology, engineering and marketing teams built a modern, future-proofed technology stack, with Twilio Segment Customer Data Platform at its core. Twilio Segment empowers the brand to move quickly and iterate, enabling...",
      button: "Read their story",
      href: (0,getAbsoluteUrl/* default */.Z)("/customers/toggle/", pageConfig)
    }]
  }, {
    title: "Advancing Maturity",
    resources: [{
      asset: (DefaultThumbnail_default()),
      type: "Blog",
      title: "Personalize Your Twilio IVR with Segment",
      excerpt: "This blog covers how, with Segment, it has never been easier to obtain, aggregate, and act on customer interaction with any product your company provides. You can use this information to improve your product, send tailored marketing messages, or tailor your customer service to your customers' needs.",
      button: "Read it here",
      href: (0,getAbsoluteUrl/* default */.Z)("https://segment.com/blog/personalize-ivr-segment-flex/", {
        baseUrl: TWILIO_URL,
        basePath: pageConfig.basePath
      })
    }]
  }, {
    title: "Adaptive Maturity",
    resources: [{
      asset: (DefaultThumbnail2_default()),
      type: "Blog",
      title: "Build Quick Customer Audiences with RFM Modelling",
      excerpt: "The term 'RFM' stands for Recency, Frequency, and Monetary Value Tracking. These three fairly straightforward characteristics allow you to quickly build complex models about how your customers relate to your brand, and how you should engage with them.",
      button: "Read more",
      href: (0,getAbsoluteUrl/* default */.Z)("https://segment.com/blog/rfm-modeling-customer-audiences/", pageConfig)
    }, {
      asset: (DefaultThumbnail_default()),
      type: "Recipe",
      categories: ["Startup", "Mobile", "Retail", "B2B", "Media"],
      title: "Run Predictive Analytics with SQL Commands",
      excerpt: "In this recipe, you learn how to use Segment and AWS Redshift ML together to generate predictive analytics without writing any code, spinning up any data pipelines, or requiring significant ML experience.",
      authorLogo: AuthorLogo,
      authorName: "Made by Segment",
      button: "Use this recipe",
      href: (0,getAbsoluteUrl/* default */.Z)("/recipes/run-predictive-analytics-with-sql-commands/", pageConfig)
    }, {
      asset: (CustomerStoryEndeavor_default()),
      type: "Customer Story",
      title: "How Endeavor used Twilio Segment to Drive Digital Transformation",
      excerpt: "Endeavor, parent company of IMG, WME, and UFC, turned to Twilio Segment to centralize its data collection, scale its data infrastructure, and share information throughout the company ecosystem. With visibility into customer behaviors, teams use analytics and other downstream tools to ge...",
      button: "Read their story",
      href: (0,getAbsoluteUrl/* default */.Z)("/customers/endeavor/", pageConfig)
    }, {
      asset: (CustomerStoryDominos_default()),
      type: "Customer Story",
      title: "How Domino\u2019s Decreased Cost-Per-Acquisition by 65% with Twilio Segment",
      excerpt: "Domino\u2019s turned to Twilio Segment to create a universal view of the customer, better visibility of ad campaign effectiveness, and create hyper personalized audiences with Twilio Engage to increase ROAS, revenue and incremental orders across all paid and owned e-commerce channels. Ultimately, Domino's...",
      button: "Read their story",
      href: (0,getAbsoluteUrl/* default */.Z)("/customers/dominos/", pageConfig)
    }, {
      asset: (CustomerStoryAllergan_default()),
      type: "Customer Story",
      title: "How Allergan Built a Loyalty Program to Generate $400 Million in Sales",
      excerpt: "Allergan built a powerful new intelligent customer engagement architecture with Segment, Twilio, and Snowflake that allows its teams to deliver the right message directly to their patients, and enabled the company to relaunch its personalized customer loyalty program, All\u0113, resulting in...",
      button: "Read their story",
      href: (0,getAbsoluteUrl/* default */.Z)("/customers/allergan/", pageConfig)
    }]
  }];
};

/* harmony default export */ var CustomerDataMaturityResources_data = (data);
;// CONCATENATED MODULE: ./src/views/CustomerDataMaturityResources/CustomerDataMaturityResources.tsx














var CustomerDataMaturityResources_copy = {
  pageTitle: "Customer Data Maturity Resource Accompaniment | Twilio Segment",
  pageDescription: "To help guide you through this book, we\u2019ve collected a series of resources to aid you on your customer data journey."
};

var CustomerDataMaturityResourcesView = function CustomerDataMaturityResourcesView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: CustomerDataMaturityResources_copy.pageTitle,
      pageDescription: CustomerDataMaturityResources_copy.pageDescription,
      bodyBackground: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), CustomerDataMaturityResources_data(pageConfig).map(function (_ref, index) {
          var title = _ref.title,
              resources = _ref.resources;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourcesSection_ResourcesSection, {
              title: title,
              resources: resources
            }), index + 1 !== CustomerDataMaturityResources_data.length && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerSection/* default */.Z, {})]
          }, title);
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterCompact/* default */.Z, {})]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1nbpopg0"
} : 0)("background-color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var CustomerDataMaturityResources_CustomerDataMaturityResources = (CustomerDataMaturityResourcesView);
;// CONCATENATED MODULE: ./src/pages/customer-data-maturity-resources/index.tsx



var CustomerDataMaturityResources = function CustomerDataMaturityResources() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomerDataMaturityResources_CustomerDataMaturityResources, {});
};

/* harmony default export */ var customer_data_maturity_resources = (CustomerDataMaturityResources);

/***/ }),

/***/ 12795:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;

var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var _loadable = _interop_require_default(__webpack_require__(84949));

function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable["default"];
  var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _extends({}, loadableOptions, dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _extends({}, loadableOptions, options); // Error if Fizz rendering is not enabled and `suspense` option is set to true

  if (false) {}

  if (loadableOptions.suspense) {
    if (false) {}

    delete loadableOptions.ssr;
    delete loadableOptions.loading;
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
  // skip `ssr` for suspense mode and opt-in React.lazy directly


  if (typeof loadableOptions.ssr === 'boolean' && !loadableOptions.suspense) {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react["default"].createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 49749:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;

var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var LoadableContext = _react["default"].createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ 84949:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(22624);

var _createClass = __webpack_require__(85458);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(2784));

var _loadableContext = __webpack_require__(49749);

var _ref =  true ? __webpack_require__(2784) : 0,
    useSyncExternalStore = _ref.useSyncExternalStore;

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  })["catch"](function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj["default"] : obj;
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);

  if (opts.suspense) {
    opts.lazy = _react["default"].lazy(opts.loader);
  }
  /** @type LoadableSubscription */


  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true) {
    // require.resolveWeak check is needed for environments that don't have it available like Jest
    var moduleIds = opts.webpack && "function" === 'function' ? opts.webpack() : opts.modules;

    if (moduleIds) {
      READY_INITIALIZERS.push(function (ids) {
        var _iterator = _createForOfIteratorHelper(moduleIds),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var moduleId = _step.value;

            if (ids.indexOf(moduleId) !== -1) {
              return init();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }

  function useLoadableModule() {
    init();

    var context = _react["default"].useContext(_loadableContext.LoadableContext);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }
  }

  function LoadableImpl(props, ref) {
    useLoadableModule();
    var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);

    _react["default"].useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    return _react["default"].useMemo(function () {
      if (state.loading || state.error) {
        return _react["default"].createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react["default"].createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  }

  function LazyImpl(props, ref) {
    useLoadableModule();
    return _react["default"].createElement(opts.lazy, _extends({}, props, {
      ref: ref
    }));
  }

  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;

  LoadableComponent.preload = function () {
    return init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return _react["default"].forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      })["catch"](function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _extends({}, this._state, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks["delete"](callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 33445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.z; },
/* harmony export */   "l": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.l; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62073);


/***/ }),

/***/ 16164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Paper_Paper; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/components/Paper/Paper.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "etxif140"
} : 0)("background:", function (_ref) {
  var background = _ref.background;
  return background;
}, ";border-radius:", function (_ref2) {
  var borderRadius = _ref2.borderRadius;
  return borderRadius;
}, "px;border:", function (_ref3) {
  var border = _ref3.border;
  return border;
}, ";width:100%;height:100%;box-shadow:", function (_ref4) {
  var theme = _ref4.theme,
      elevation = _ref4.elevation;
  return theme.shadows[elevation];
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Paper/Paper.tsx


var _excluded = ["background", "borderRadius", "border", "elevation", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var Paper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var background = _ref.background,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 10 : _ref$borderRadius,
      _ref$border = _ref.border,
      border = _ref$border === void 0 ? "none" : _ref$border,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === void 0 ? 0 : _ref$elevation,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, _objectSpread(_objectSpread({
    background: background || theme.palette.brand.boysenberry[100],
    borderRadius: borderRadius,
    border: border,
    elevation: elevation,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
/* harmony default export */ var Paper_Paper = (Paper);
;// CONCATENATED MODULE: ../../libs/matcha/components/Paper/index.ts


/***/ }),

/***/ 90629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UtilityNav_UtilityNav; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/useUtilityNavDescriptions.tsx




var useUtilityNavDescriptions = function useUtilityNavDescriptions(descriptions) {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var keys = (0,react.useMemo)(function () {
    if (!descriptions) return [];
    return Object.keys(descriptions);
  }, [descriptions]);
  var breakpointsKeys = Object.keys(theme.breakpoints.values);
  var sortedArrayOfKeys = (0,react.useMemo)(function () {
    return breakpointsKeys.filter(function (main) {
      return keys.some(function (key) {
        return key === main;
      });
    });
  }, [breakpointsKeys, keys]);

  var getNextKey = function getNextKey(key, index) {
    if (sortedArrayOfKeys[index - 1]) {
      var getIndexofCurrentKey = breakpointsKeys.indexOf(key);

      if (breakpointsKeys[getIndexofCurrentKey - 1] !== sortedArrayOfKeys[index - 1]) {
        return breakpointsKeys[breakpointsKeys.indexOf(key) - 1];
      }
    }

    return false;
  };

  var array = sortedArrayOfKeys.map(function (key, index) {
    var nextKey = getNextKey(key, index);
    var minWidth = sortedArrayOfKeys[index - 1] ? " and ".concat(theme.breakpoints.up(nextKey ? nextKey : key, false)) : "";
    var mediaString = "".concat(theme.breakpoints.down(key, false)).concat(minWidth);
    return (0,useMatchMedia/* default */.Z)(mediaString, true);
  });
  return descriptions[sortedArrayOfKeys[array.indexOf(true)]];
};

/* harmony default export */ var UtilityNav_useUtilityNavDescriptions = (useUtilityNavDescriptions);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e12rge5s2"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e12rge5s1"
} : 0)("padding-top:3px;margin:0 8px;font-size:", function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonSmall;
}, ";&:after{height:1px;bottom:4px;}" + ( true ? "" : 0));
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e12rge5s0"
} : 0)("width:100%;text-align:center;background:", function (_ref2) {
  var background = _ref2.background;
  return background;
}, ";padding:7px 17px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("xs");
}, "{padding:17px 40px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.tsx


var _excluded = ["announcement", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var UtilityNavBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var announcement = _ref.announcement,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var utilityNavDescriptions = "";

  if (typeof (announcement === null || announcement === void 0 ? void 0 : announcement.description) === "string") {
    utilityNavDescriptions = announcement.description;
  } else if (announcement !== null && announcement !== void 0 && announcement.description) {
    utilityNavDescriptions = UtilityNav_useUtilityNavDescriptions(announcement.description);
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    background: tokens.background,
    children: [utilityNavDescriptions && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
      variant: "buttonSmall",
      children: utilityNavDescriptions
    }), announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
      tokens: _objectSpread({}, tokens.buttonText),
      size: "small",
      href: announcement.ctaLink,
      hover: true,
      children: announcement.ctaTitle
    })]
  }));
});
var UtilityNav = (0,useDesignTokens/* withDesignTokens */.Y)(UtilityNavBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  light: function light(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  dark: function dark(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  }
});
/* harmony default export */ var UtilityNav_UtilityNav = (UtilityNav);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 52876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DividerSection_DividerSection; }
});

// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/DividerSection/DividerSection.views.tsx


var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ec103ko0"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;padding-bottom:0;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/DividerSection/DividerSection.tsx





var DividerSection = function DividerSection() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})
    })
  });
};

/* harmony default export */ var DividerSection_DividerSection = (DividerSection);

/***/ }),

/***/ 85507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _DividerSection__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _DividerSection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52876);


/***/ }),

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ GettingStarted; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseGettingStarted = function BaseGettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment." : _ref$description,
      _ref$demoUtms = _ref.demoUtms,
      demoUtms = _ref$demoUtms === void 0 ? "" : _ref$demoUtms,
      tokens = _ref.tokens;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/".concat(demoUtms), pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          variant: "outlined",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  }));
};

var GettingStarted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseGettingStarted, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/index.ts


/***/ }),

/***/ 22761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ NavigationBrand_NavigationBrand; }
});

// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts + 3 modules
var UtilityNav = __webpack_require__(90629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/index.ts + 30 modules
var Navigation_MobileNavigation = __webpack_require__(86943);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/index.ts + 8 modules
var Navbar = __webpack_require__(90806);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/MobileNavigation.tsx








var MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UtilityNav/* default */.Z, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* Navbar */.wp, {
      tokens: {
        backgroundColor: backgroundColor
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Brand */.H2, {
        href: "/",
        onClick: function onClick() {
          return (0,scripts/* trackButtonClick */.kO)({
            buttonText: "Segment Logo",
            targetUrl: "/",
            buttonCampaign: "nav"
          });
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      })
    })]
  });
};

/* harmony default export */ var NavigationBrand_MobileNavigation = (MobileNavigation);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/index.ts + 14 modules
var DesktopNavigation_Navbar = __webpack_require__(77966);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/index.ts + 24 modules
var DesktopNavigation = __webpack_require__(82680);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/DesktopNavigation.tsx







var DesktopNavigation_MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DesktopNavigation/* default */.ZP, {
    children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation/* UtilityNav */.T8, {
      announcement: announcement
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation/* Navbar */.wp, {
      tokens: {
        backgroundColor: backgroundColor
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_Navbar/* Brand */.H2, {
        href: "/",
        onClick: function onClick() {
          return (0,scripts/* trackButtonClick */.kO)({
            buttonText: "Segment Logo",
            targetUrl: "/",
            buttonCampaign: "nav"
          });
        },
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      })
    })]
  });
};

/* harmony default export */ var NavigationBrand_DesktopNavigation = (DesktopNavigation_MobileNavigation);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/NavigationBrand.tsx






var NavigationBrand = function NavigationBrand(_ref) {
  var announcement = _ref.announcement,
      backgroundColor = _ref.backgroundColor;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      greaterThanOrEqual: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand_DesktopNavigation, {
        backgroundColor: backgroundColor,
        announcement: announcement
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
      lessThan: "md",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavigationBrand_MobileNavigation, {
        backgroundColor: backgroundColor,
        announcement: announcement
      })
    })]
  });
};
/* harmony default export */ var NavigationBrand_NavigationBrand = (NavigationBrand);
;// CONCATENATED MODULE: ../../libs/templates/NavigationBrand/index.ts


/***/ }),

/***/ 1959:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * A helper function to generate the path to an image from Contentful.
 * @param props.src - The path to the image
 * @param props.width - The width of the image
 * @param props.quality - The quality of the image
 * @returns The path to the image with the width and quality parameters
 */
var contentfulImageLoader = function contentfulImageLoader(_ref) {
  var src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  return "".concat(src, "?w=").concat(width, "&q=").concat(quality || 75);
};

/* harmony default export */ __webpack_exports__["Z"] = (contentfulImageLoader);

/***/ }),

/***/ 85807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useInView; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useInView/useInView.ts

/**
 * A hook to observe elements in the viewport
 * @param ref - A ref to the element to observe
 * @param options - The options for the IntersectionObserver
 * @returns A boolean indicating if the element is in the viewport
 */

var useIsInView = function useIsInView(ref) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnIntersecti = _ref.stopOnIntersection,
      stopOnIntersection = _ref$stopOnIntersecti === void 0 ? true : _ref$stopOnIntersecti,
      options = _ref.options;

  var _useState = (0,react.useState)(false),
      isInView = _useState[0],
      setIsInView = _useState[1];

  var inViewRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(function (intersection) {
      if (intersection.some(function (i) {
        return i.isIntersecting;
      })) {
        inViewRef.current = true;
        setIsInView(true);

        if (stopOnIntersection) {
          intersectionObserver.disconnect();
        }
      } else if (inViewRef.current) {
        inViewRef.current = false;
        setIsInView(false);
      }
    }, options);

    if (ref.current) {
      intersectionObserver.observe(ref.current);
    }

    return function () {
      intersectionObserver.disconnect();
    };
  }, [ref]);
  return isInView;
};

/* harmony default export */ var useInView = (useIsInView);
;// CONCATENATED MODULE: ../../libs/utils/useInView/index.ts


/***/ }),

/***/ 89963:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-data-maturity-resources",
      function () {
        return __webpack_require__(1421);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(12795)


/***/ }),

/***/ 61368:
/***/ (function(module) {

module.exports = "/_next/static/images/AnalyticsAcademy-d38672c7922a81a5e400ff946a2681c2.png";

/***/ }),

/***/ 80408:
/***/ (function(module) {

module.exports = "/_next/static/images/CustomerStoryAllergan-f76d9821c8462fd3ca61dac3b9673192.png";

/***/ }),

/***/ 14946:
/***/ (function(module) {

module.exports = "/_next/static/images/CustomerStoryDominos-32a025d5247bc003de63fdd38f6e0514.png";

/***/ }),

/***/ 83063:
/***/ (function(module) {

module.exports = "/_next/static/images/CustomerStoryEndeavor-d8ff09fbc372b537fbdeff64200513db.png";

/***/ }),

/***/ 1866:
/***/ (function(module) {

module.exports = "/_next/static/images/CustomerStoryFender-a1786ac436645ab0d4f61480a9e420e2.png";

/***/ }),

/***/ 84985:
/***/ (function(module) {

module.exports = "/_next/static/images/CustomerStoryIbm-ff67c5ff00a4c4d81d46515039d6f6d7.png";

/***/ }),

/***/ 45389:
/***/ (function(module) {

module.exports = "/_next/static/images/CustomerStoryToggle-aaf1cf7401912d62276adb5a1618bb1c.png";

/***/ }),

/***/ 84257:
/***/ (function(module) {

module.exports = "/_next/static/images/DefaultThumbnail-d5ef731fc7a921c5df5aaffdc7439f51.png";

/***/ }),

/***/ 58951:
/***/ (function(module) {

module.exports = "/_next/static/images/DefaultThumbnail2-04d5ec25bb17accc21dca9e2a9641288.png";

/***/ }),

/***/ 141:
/***/ (function(module) {

module.exports = "/_next/static/images/IdentityResolutionGuide-f2dca3536375e1bcf6513f942ed47225.png";

/***/ }),

/***/ 74253:
/***/ (function(module) {

module.exports = "/_next/static/images/JumpstartLite-9999491e9266f3abc20821e4dae7a688.png";

/***/ }),

/***/ 90032:
/***/ (function(module) {

module.exports = "/_next/static/images/StreamlineCompliance-dfa18768130ba32d778f93332958a5a4.png";

/***/ }),

/***/ 89796:
/***/ (function(module) {

module.exports = "/_next/static/images/The4StepGuide-63ed388f21260951fdd8b6f74cb4b133.png";

/***/ }),

/***/ 48319:
/***/ (function(module) {

module.exports = "/_next/static/images/WhatDoesItTake-39c96216e0b037559c76be6469af13ad.png";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,1382,4136,8392,2073,7096,2429,442,4881,9524,9774,2888,179], function() { return __webpack_exec__(89963); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);